var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path, _polygon8, _path2, _path3, _polygon9, _polygon10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSponsor9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147.4 31.7",
    style: {
      enableBackground: "new 0 0 147.4 31.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D3D5D6;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#ADAFB2;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#75BEE9;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#0072BC;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#F37164;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#ED1B35;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#4D4D4F;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_15_",
    className: "st0",
    points: "97.5,31.7 111.1,31.7 102.5,10 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_14_",
    className: "st1",
    points: "98.6,0 102.5,10 111.1,31.7 116.1,10 112.2,0 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_13_",
    className: "st2",
    points: "113.1,31.7 118.2,10 126.7,31.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_12_",
    className: "st3",
    points: "131.7,10 126.7,31.7 118.2,10 114.2,0 127.8,0 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_10_",
    className: "st4",
    points: "128.8,31.7 133.8,10 142.4,31.7 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8_",
    className: "st5",
    points: "147.4,10 142.4,31.7 133.8,10 129.9,0 143.4,0 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_11_",
    className: "st6",
    points: "12,19 12,10.6 8.1,19 6.8,19 3,10.6 3,19 0,19 0,7 4.1,7 7.5,14.2 10.8,7 15,7 15,19   "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st6",
    d: "M16.1,13c0-3.8,3.1-6.5,7.2-6.5c3,0,4.7,1.5,5.6,3.1l-2.5,1.1c-0.6-1-1.8-1.8-3.2-1.8  c-2.4,0-4.2,1.7-4.2,4.1s1.8,4.1,4.2,4.1c1.4,0,2.6-0.8,3.2-1.8l2.5,1.1c-1,1.6-2.7,3.1-5.6,3.1C19.3,19.5,16.1,16.9,16.1,13"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7_",
    className: "st6",
    points: "39.7,19.3 39.7,9.1 33.4,9.1 33.4,19.3 30.5,19.3 30.5,6.8 42.6,6.8 42.6,19.3 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.9,6.8v2.3h-7v2.2h3.5c2.9,0,4.5,1.8,4.5,4c0,2.2-1.6,4-4.5,4H50V6.8H59.9z M52.9,13.7v3.3H56  c1.1,0,1.9-0.6,1.9-1.6c0-1-0.8-1.6-1.9-1.6H52.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M68.3,19.3v-0.9c-0.7,0.7-1.8,1.2-3.1,1.2c-1.6,0-3.4-1-3.4-3c0-2.1,1.8-2.9,3.4-2.9c1.3,0,2.4,0.4,3.1,1.1  v-1.2c0-0.9-0.9-1.5-2.1-1.5c-1,0-2,0.4-2.8,1.1l-1-1.6c1.2-1,2.7-1.4,4.3-1.4c2.2,0,4.3,0.8,4.3,3.4v5.9H68.3z M68.3,17.1V16  c-0.4-0.5-1.2-0.8-2.1-0.8c-1,0-1.8,0.5-1.8,1.4c0,0.8,0.8,1.3,1.8,1.3C67,17.9,67.8,17.6,68.3,17.1z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3_",
    className: "st6",
    points: "73.2,19.3 73.2,10.2 75.7,10.2 75.7,13.6 79.8,13.6 79.8,10.2 82.3,10.2 82.3,19.3   79.8,19.3 79.8,15.7 75.7,15.7 75.7,19.3 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1_",
    className: "st6",
    points: "91,19.3 88.4,15.8 87.3,16.9 87.3,19.3 84.7,19.3 84.7,10.2 87.3,10.2 87.3,14.2   91,10.2 94.1,10.2 90.2,14.3 94.2,19.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsor9);
export default __webpack_public_path__ + "static/media/sponsor_9.033ce86f3561f1c44638d1bd199f5bbd.svg";
export { ForwardRef as ReactComponent };